<template>
    <section class="tile h-100 mb-2">
        <div class="container h-100 mw-100 border-2">
            <div class="row h-100">
                <div
                    class="d-flex flex-column px-0 h-100 w-100 bg-header-tile align-items-stretch"
                    :style="pushAnimationTileStyle"
                    :class="pushAnimationTileClasses"
                >
                    <!--/* BANNIERE + TIMER */-->
                    <tag-timer-banner
                        :banner="pushAnimationBanner.tag"
                        :timer-end-date-in-milliseconds="pushAnimationBanner.timerEndDateInMilliseconds"
                        :count-down-color="pushAnimationBanner.countDownColor"
                    />

                    <div class="flex-grow-1 pt-1">
                        <div
                            class="h-100 d-flex flex-column justify-content-center align-content-center text-center px-1 pb-2"
                            :class="pushAnimationTileTextClasses"
                        >
                            <div v-if="pushAnimation.picture" class="mt-0 mb-2 mx-auto">
                                <img
                                    class="img-fluid"
                                    loading="lazy"
                                    :src="pushAnimation.picture.src"
                                    :alt="pushAnimation.picture.alt"
                                >
                            </div>

                            <span v-if="pushAnimation.title" class="mt-0 h4 my-0 mx-auto" v-html="pushAnimation.title" />

                            <span v-if="pushAnimation.text" class="mt-0 lead mx-auto" v-html="pushAnimation.text" />

                            <span v-if="pushAnimation.additionalText" class="mt-0 small mx-auto" v-html="pushAnimation.additionalText" />

                            <div v-if="pushAnimationLink" class="mt-1 mx-auto">
                                <a
                                    :href="pushAnimationLink.href"
                                    :class="pushAnimationLink.classes"
                                    :data-oevent-category="pushAnimationLink.tms.category"
                                    :data-oevent-action="pushAnimationLink.tms.action"
                                    :data-oevent-label="pushAnimationLink.tms.label"
                                    target="_self"
                                    v-html="pushAnimationLink.label"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import TagTimerBanner from "./TagTimerBanner.vue";

export default {
    name: "InternetPushAnimationTile",
    components: {
        TagTimerBanner
    },
    props: {
        pushAnimation: {type: Object, required: true}
    },
    computed: {
        pushAnimationTileStyle() {
            if (this.pushAnimation.backgroundImage && this.pushAnimation.backgroundImage.src) {
                return 'background-image: url('+ this.pushAnimation.backgroundImage.src +'); background-size: cover;  background-position: center;'
            } else {
                return ''
            }
        },
        pushAnimationTileClasses() {
            return [this.pushAnimation.backgroundColor]
        },
        pushAnimationTileTextClasses() {
            return {
                "text-white": this.pushAnimation.backgroundColor === "bg-primary" ||
                                this.pushAnimation.backgroundColor === "bg-secondary" ||
                                this.pushAnimation.backgroundColor === "bg-dark" ||
                                this.pushAnimation.backgroundColor === "bg-black" ||
                                this.pushAnimation.backgroundColor === "bg-gray1" ||
                                this.pushAnimation.backgroundColor === "bg-gray3"
            }
        },
        pushAnimationLink() {
            if ( this.pushAnimation.button && this.pushAnimation.button.label && this.pushAnimation.button.url && this.pushAnimation.button.tms) {
                if (this.pushAnimation.button.link) {
                    return {
                        label: this.pushAnimation.button.label,
                        href: this.pushAnimation.button.url,
                        classes: "ob1-link ob1-link-arrow no-decoration",
                        tms: this.pushAnimation.button.tms
                    }
                } else {
                    return {
                        label: this.pushAnimation.button.label,
                        href: this.pushAnimation.button.url,
                        classes: {
                            "btn": true,
                            "btn-secondary": true,
                            "btn-inverse": ["bg-primary", "bg-secondary", "bg-dark", "bg-black", "bg-gray1", "bg-gray3"].includes(this.pushAnimation.backgroundColor)
                        },
                        tms: this.pushAnimation.button.tms
                    }
                }
            } else {
                return undefined
            }
        },
        pushAnimationBanner() {
            return {
                tag: this.pushAnimation.tag,
                timerEndDateInMilliseconds: (this.pushAnimation.timer) ? this.pushAnimation.timer.endDateInMilliseconds : undefined,
                countDownColor: this.pushAnimationTileTextClasses
            }
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">

</style>
